import { CompanySettings } from "../entities/CompanySettings";
import { SettingsRepository } from "../repositories/SettingsRepository";

/**
 * ZOUR-19 item 13 — fills a blank company GSTIN from Zoho Books.
 *
 * A client migrating from non-GST has no GSTIN, and `gst_number` is
 * master-owned and locked on the panel, so nothing in the tenant could set one.
 * That is not cosmetic: `invoice_validation_lib` stamps our GSTIN onto every
 * bill as the buyer, so with it blank the first post-switch bill is flagged
 * "Expecting B2B but got B2C".
 *
 * The off -> on flip copies it automatically. This is for a tenant that has
 * already flipped — which is every migrating client by the time anyone notices.
 * The server refuses to overwrite a GSTIN that is already set.
 */
export class UseZohoGstinUseCase {
  constructor(private readonly repository: SettingsRepository) {}

  execute(signal?: AbortSignal): Promise<CompanySettings> {
    return this.repository.useZohoGstin(signal);
  }
}
